/* eslint-disable */
import React from 'react';
import language from '../../assets/languages/language';

class AlertMessage extends React.Component {
  constructor(props) {
    super(props);
    // ============CFA- 1 message============
    this.messageContent_cfa_1 = `<div class="modal-info-list"><ul> <li> ${'Extensive Study Notes'} </li> <li> ${'40+ Hours of Video Lessons'} </li> <li> ${'3,000+ Practice Questions'} </li><li> ${'5 Full-Length Mock Exams'} </li> <li> ${'Unlimited Customizable Quizzes'} </li> <li> ${'Tutors Answering your Questions via Live Chat'}</li></ul></div>`;
    // =============FRM  message=============
    this.messageContent_frm = `<div class="modal-info-list"><ul> <li> ${'Extensive Study Notes'} </li> <li> ${'30+ Hours of Video Lessons for each Part'} </li> <li> ${'2,000 Practice Questions for each Part'} </li> <li> ${'Unlimited Customizable Quizzes'} </li> <li> ${'Tutors Answering your Questions via Live Chat'}</li></ul></div>`;

    // =============CFA-2 message=======

    this.messageContent_cfa_2 = `<div class="modal-info-list"><ul> <li> ${'200 Item Sets'} </li> <li> ${'2 Full-Length Mock Exams'} </li><li> ${'Unlimited Customizable Quizzes'} </li> <li> ${'Tutors Answering your Questions via Live Chat'}</li></ul></div>`;

    // ===============CFA -3 mesage =========
    this.messageContent_cfa_3 = `<div class="modal-info-list"><ul> <li> ${'100 Item Sets'} </li> <li> ${'Essay Questions'} </li>  <li> ${'Unlimited Customizable Quizzes'} </li> <li> ${'Tutors Answering your Questions via Live Chat'}</li></ul></div>`;

    // =============== ESG mesage =========
    this.messageContent_ESG = `<div class='modal-info-list'>
    <ul>
      <li> Extensive Study Notes </li>
      <li> 3500+ Practice Questions </li>
      <li> 2 Full-Length Mock Exams </li>
      <li> Tutors Answering your Questions via Live Chat</li>
    </ul>
  </div>`;

    // ==========SOA _ P message =========
    this.messageContent_soa_p = `<div class="modal-info-list"><ul> <li> ${'Extensive Study Notes'} </li><li> ${'1,500+ Practice Questions'} </li><li> ${'Unlimited Customizable Quizzes'} </li> <li> ${'Tutors Answering your Questions via Live Chat'}</li></ul></div>`;

    // ==========SOA - FM message =========
    this.messageContent_soa_fm = `<div class="modal-info-list"><ul> <li> ${'Extensive Study Notes'} </li>  <li> ${'40+ Hours of Video Lessons'} </li>  <li> ${'1,500+ Practice Questions'} </li><li> ${'Unlimited Customizable Quizzes'} </li> <li> ${'Tutors Answering your Questions via Live Chat'}</li></ul></div>`;

    // ==========GMAT message =========
    this.messageContent_gmat = `<div class="modal-info-list"><ul> <li> ${
      language.LC().Hours_of_Video_Lessons_35
    } </li> <li> ${language.LC().Quant_Questions} </li><li> ${
      language.LC().Verbal_Questions
    } </li> <li> ${language.LC().Integrated_Reasoning_Questions} </li> <li> ${
      language.LC().Advanced_Analytics_Dashboard
    } </li><li> ${language.LC().AskATutor_Questions}</li></ul></div>`;
  }
}

export default new AlertMessage();



// WEBPACK FOOTER //
// ./src/views/config/alertMessage.js